import { Injectable } from "@angular/core";
import { IID_RISORSE_IRU_ACQUISIZIONE } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "@ep-om/project/state/action/action.service";
import { CrudService } from "@ep-om/project/state/crudService";
import { ProjectEntityStoreStrategy } from "@ep-om/project/state/updateStoreStrategies";
import { IIDRisorseIruAcquisizioneQuery } from "./iidRisorseIruAcquisizione.query";
import { IIDRisorseIruAcquisizioneStore } from "./iidRisorseIruAcquisizione.store";
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.RISORSE_IRU_ACQUISIZIONE)
export class IIDRisorseIruAcquisizioneService extends CrudService<IID_RISORSE_IRU_ACQUISIZIONE, IIDRisorseIruAcquisizioneStore, IIDRisorseIruAcquisizioneQuery> {
  constructor(
    protected store: IIDRisorseIruAcquisizioneStore,
    public query: IIDRisorseIruAcquisizioneQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy
  ) {
    super(Topics.IID_RISORSE_IRU_ACQUISIZIONE, store, query, actionService, updateStrategy);
  }
}
